import { useAppContext } from '@frx/frx-react-context';

export const useTeamId = (): number => {
  const {
    data: {
      authData: { user },
    },
  } = useAppContext();

  const url = user?.teamPageUrl || '';
  const teamId = parseFloat(new URL(url).searchParams.get('team_id') || '');
  return teamId;
};
